export const CompType =
  'wysiwyg.common.components.verticalanchorsmenu.viewer.VerticalAnchorsMenu';
export const PropertiesType = 'VerticalAnchorsMenuProperties';
export const DataType = 'VerticalAnchorsMenu';
export const PAGE_ANCHORS = {
  TOP_ANCHOR_ID: 'SCROLL_TO_TOP',
  TOP_ANCHOR_COMP_ID: 'PAGE_TOP_ANCHOR',
};
